import { CircularProgress, MenuItem, Select } from "@material-ui/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { fgetBFF, fpatch } from "../../../../API/callsAPI";
import commonStyles from "../../../../Utils/commonStyles";
import NoResultMessage from "../../../Utilities/NoResultFound/NoResultMessage";
import UpdatesPageUpdateCards from "../../UpdatesPageUpdateCards/UpdatesPageUpdateCards.component";
import useStyles from "./ProjectUpdates.style";

const ProjectUpdates = ({ users, projectId, statusList }) => {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const [nextPageLoading, setNextPageLoading] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(5);
  const [selectedTrackable, setSelectedTrackable] = useState("all");
  useEffect(() => {
    if (pageNumber !== 0) fetchUpdates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  useEffect(() => {
    fetchUpdates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTrackable]);

  const handleFilterByTrackable = (trackableId) => {
    setUpdates([]);
    setPageNumber(0);
    setHasMore(false);
    setSelectedTrackable(trackableId);
  };

  //Function to fetch pagination on scroll
  const observer = useRef();
  const lastBookReference = useCallback(
    (node) => {
      if (nextPageLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber(pageNumber + 5);
        }
      });
      if (node) observer.current.observe(node);
    },
    [nextPageLoading, hasMore]
  );

  //Function to mark a update as read
  const markAsRead = async (updateId) => {
    const updateFilter = updates.filter((item) => item.id !== updateId);
    try {
      await fpatch({
        url: `updates/${updateId}/`,
        data: { isRead: true },
      });
      setUpdates([...updateFilter]);
    } catch (error) {
      console.log(error);
    }
  };

  //Bff Function to fetchUpdates
  const fetchUpdates = async () => {
    setNextPageLoading(true);
    setHasMore(false);
    try {
      const res = await fgetBFF({
        url: `web/updates/?project=${projectId}&offset=${pageNumber}&page_size=${pageSize}&trackable=${
          selectedTrackable === "all" ? "" : selectedTrackable
        }`,
      });
      if (res.status === 200) {
        setNextPageLoading(false);
        if (res.data.updates.results) {
          setUpdates((prevUpdates) => [
            ...prevUpdates,
            ...res.data.updates.results,
          ]);
        }
        if (res.data.updates.next) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.log(error);
      setNextPageLoading(false);
    }
  };
  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          className={commonClasses.responsiveTitleTextSize}
          style={{
            fontWeight: 600,
            marginBottom: "14px",
            textAlign: "center",
          }}
        >
          Project Updates
        </div>
        <div className={classes.cardContentDiv2}>
          <Select
            style={{ width: "150px", fontSize: "12px" }}
            disableUnderline
            className={classes.cardContentInput1}
            value={selectedTrackable}
            onChange={(e) => handleFilterByTrackable(e.target.value)}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="12">Assets</MenuItem>
            <MenuItem value="18">Asset V</MenuItem>
            <MenuItem value="13">Sequence</MenuItem>
            <MenuItem value="14">Shots</MenuItem>
            <MenuItem value="17">Shot V</MenuItem>
          </Select>
        </div>
      </div>
      <div
        style={{
          height: "98%",
          overflowY: "auto",
          paddingRight: "10px",
          // marginTop: "14px",
        }}
      >
        {updates?.length ? (
          <>
            {updates.map((update, index) => {
              if (updates.length === index + 1) {
                return (
                  <div ref={lastBookReference} key={update.id}>
                    <UpdatesPageUpdateCards
                      update={update}
                      users={users}
                      statusList={statusList}
                      updateRefreshCounter={() => fetchUpdates()}
                    />
                  </div>
                );
              }
              return (
                <div key={update.id}>
                  <UpdatesPageUpdateCards
                    markAsRead={markAsRead}
                    users={users}
                    update={update}
                    projectId={projectId}
                    statusList={statusList}
                    updateRefreshCounter={() => fetchUpdates()}
                  />
                </div>
              );
            })}
          </>
        ) : (
          <div
            className={classes.flexCenter}
            style={{
              height: "80%",
              display: nextPageLoading ? "none" : "flex",
            }}
          >
            <NoResultMessage name="Updates" iconSize={50} fontSize="28px" />
          </div>
        )}
        {nextPageLoading ? (
          <div className={classes.flexCenter}>
            <CircularProgress
              type="Oval"
              color="secondary"
              height={50}
              width={50}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProjectUpdates;
